import APricingStandardAdditionalFeesBulkEdit
    from 'app/Apps/Rates/ARateCards/StandardAdditionalFees/APricingStandardAdditionalFeesBulkEdit'
import APricingStandardBaseLeaseBulkEdit
    from 'app/Apps/Rates/ARateCards/StandardBaseLease/APricingStandardBaseLeaseBulkEdit'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import {
    SkyNetDomainRoutes,
} from 'app/shared-components/SkyNetDomain'
import {
    BulkActionWrapper,
} from 'app/shared-components/SkyNetObjectProfile'
import {
    createSkyNetObjectRoutes,
} from 'app/shared-components/SkyNetObjectProfile/SkyNetObjectRoutes.utils'
import {
    SkyNetRouteObject,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'

import ARateCardsPage from './ARateCardsPage'
import domainConfig from './ARateCards.config'

export default createSkyNetObjectRoutes(<ARateCardsPage />, domainConfig, [{
    path: `${SkyNetDomainRoutes.BULK_EDIT}/:key`,
    children: [
        {
            path: RateCardsTabs.BaseLease,
            element: (
                <BulkActionWrapper
                    component={APricingStandardBaseLeaseBulkEdit}
                />
            ),
            accessOnly: ['a_pricing_rates_update'],
        },
        {
            path: RateCardsTabs.AdditionalFees,
            element: (
                <BulkActionWrapper
                    component={APricingStandardAdditionalFeesBulkEdit}
                />
            ),
            accessOnly: ['a_pricing_rates_update'],
        },
    ] as SkyNetRouteObject[],
}])
